import React from 'react';
import { useNavigate } from 'react-router-dom';

import logo from '@/assets/icons/generals/logoFullWhite.svg';

import {
  // Contact,
  Container,
  Logo,
} from './styles';

const Footer: React.FC = () => {
  const navigate = useNavigate();
  return (
    <Container>
      <Logo
        src={logo}
        onClick={() => {
          navigate('/proprietario');
        }}
        alt="logo seazone"
        data-cy="img-logo-seazone-footer"
      />
      {/* <Contact>
      <p />
    </Contact> */}
    </Container>
  );
};

export default Footer;
